import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ErrorOutline } from "@mui/icons-material";

import { useAudienceMutations } from "@/hooks";
import { DialogComponentProps } from "@/context";

type UnshareAudienceDialogProps = DialogComponentProps<"unshareAudience">;

const UnshareAudienceDialog: React.FC<UnshareAudienceDialogProps> = ({
  audience,
  open,
  onClose,
}) => {

  const { unshare, action } = useAudienceMutations(audience);

  return (
    <Dialog open={open} disableEnforceFocus aria-labelledby="delete-dialog">
      <DialogTitle>
        <Typography>Remove Shared Audience</Typography>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography>
          Please confirm you wish to remove <b>{audience.audience_name}</b> as a shared audience.
          In order to see the audience again, the audience must be re-shared with you.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="info" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={unshare}
          loading={action.status === 'loading'}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnshareAudienceDialog;
